// 中文作文學習卡片數據結構，系統性組織
export const flashCardLanguages = [
  { id: 'zh-tw', name: '繁體中文', code: 'zh-TW' },
  { id: 'zh-cn', name: '簡體中文', code: 'zh-CN' },
  { id: 'en', name: 'English', code: 'en-US' },
  { id: 'es', name: 'Español', code: 'es-ES' },
  { id: 'fr', name: 'Français', code: 'fr-FR' },
  { id: 'de', name: 'Deutsch', code: 'de-DE' },
  { id: 'ja', name: '日本語', code: 'ja-JP' },
  { id: 'ko', name: '한국어', code: 'ko-KR' }
];

export const flashCardDifficulties = [
  { id: 'beginner', name: '初級', description: '基本概念和術語' },
  { id: 'intermediate', name: '中級', description: '標準教育水平' },
  { id: 'advanced', name: '高級', description: '複雜概念和分析' },
  { id: 'expert', name: '專家', description: '專業和專門知識' }
];

export const flashCardCategories = [
  { id: 'narrative', name: '記敘文', icon: '📖', color: 'bg-blue-100 text-blue-800' },
  { id: 'descriptive', name: '描寫文', icon: '🖼️', color: 'bg-green-100 text-green-800' },
  { id: 'expository', name: '說明文', icon: '📋', color: 'bg-purple-100 text-purple-800' },
  { id: 'argumentative', name: '議論文', icon: '⚖️', color: 'bg-red-100 text-red-800' },
  { id: 'practical', name: '應用文', icon: '📝', color: 'bg-orange-100 text-orange-800' },
  { id: 'grammar', name: '語法', icon: '📚', color: 'bg-indigo-100 text-indigo-800' },
  { id: 'vocabulary', name: '詞彙', icon: '🗣️', color: 'bg-pink-100 text-pink-800' },
  { id: 'structure', name: '結構', icon: '🏗️', color: 'bg-cyan-100 text-cyan-800' },
  { id: 'rhetoric', name: '修辭', icon: '✨', color: 'bg-emerald-100 text-emerald-800' },
  { id: 'general', name: '通用知識', icon: '🧠', color: 'bg-gray-100 text-gray-800' }
];

// 中文作文學習卡片範例集
export const sampleFlashCardSets = [
  {
    id: 'narrative-writing-zh',
    title: '記敘文寫作技巧',
    language: '繁體中文',
    difficulty: 'intermediate',
    category: 'narrative',
    totalCards: 5,
    description: '記敘文的基本寫作方法和技巧',
    createdAt: '2024-01-15T10:00:00Z',
    cards: [
      {
        id: 1,
        question: '記敘文的六要素是什麼？',
        answer: '時間、地點、人物、事件的起因、經過、結果',
        explanation: '記敘文必須包含這六個基本要素，才能構成一個完整的故事。',
        category: 'narrative',
        keywords: ['記敘文', '六要素', '寫作基礎'],
        imageQuery: 'storytelling narrative writing',
        imageUrl: 'https://source.unsplash.com/800x600/?storytelling,writing,narrative',
        imageAlt: '記敘文寫作插圖'
      },
      {
        id: 2,
        question: '記敘文常用的敘述順序有哪些？',
        answer: '順敘、倒敘、插敘',
        explanation: '順敘按時間順序敘述；倒敘先說結果再說原因；插敘在敘述中插入相關情節。',
        category: 'narrative',
        keywords: ['敘述順序', '順敘', '倒敘', '插敘'],
        imageQuery: 'timeline sequence story',
        imageUrl: 'https://source.unsplash.com/800x600/?timeline,sequence,story',
        imageAlt: '敘述順序示意圖'
      },
      {
        id: 3,
        question: '記敘文中如何突出中心思想？',
        answer: '通過典型事例、詳略得當的安排、恰當的議論和抒情',
        explanation: '選擇最能表現主題的事例，重點詳寫，次要略寫，適當加入議論抒情。',
        category: 'narrative',
        keywords: ['中心思想', '詳略', '議論', '抒情'],
        imageQuery: 'focus theme writing',
        imageUrl: 'https://source.unsplash.com/800x600/?focus,theme,writing',
        imageAlt: '突出主題示意圖'
      },
      {
        id: 4,
        question: '記敘文的開頭有哪些常用方法？',
        answer: '開門見山、設置懸念、環境描寫、引用名言',
        explanation: '好的開頭能吸引讀者注意，為全文定下基調。',
        category: 'narrative',
        keywords: ['開頭', '開門見山', '懸念', '環境描寫'],
        imageQuery: 'beginning start writing',
        imageUrl: 'https://source.unsplash.com/800x600/?beginning,start,writing',
        imageAlt: '文章開頭技巧'
      },
      {
        id: 5,
        question: '記敘文如何做到生動具體？',
        answer: '運用細節描寫、對話描寫、心理描寫、動作描寫',
        explanation: '通過各種描寫手法，讓人物形象鮮明，事件過程清晰，增強文章的感染力。',
        category: 'narrative',
        keywords: ['細節描寫', '對話', '心理描寫', '動作描寫'],
        imageQuery: 'detail description writing',
        imageUrl: 'https://source.unsplash.com/800x600/?detail,description,writing',
        imageAlt: '描寫技巧示意圖'
      }
    ]
  },
  {
    id: 'rhetoric-techniques-zh',
    title: '中文修辭技巧',
    language: '繁體中文',
    difficulty: 'advanced',
    category: 'rhetoric',
    totalCards: 6,
    description: '常用的中文修辭手法及其運用',
    createdAt: '2024-01-16T14:30:00Z',
    cards: [
      {
        id: 1,
        question: '比喻的作用是什麼？',
        answer: '使抽象的事物具體化，深奧的道理淺顯化，陌生的事物熟悉化',
        explanation: '比喻能夠幫助讀者更好地理解和感受作者要表達的內容。',
        category: 'rhetoric',
        keywords: ['比喻', '修辭', '具體化'],
        imageQuery: 'metaphor comparison writing',
        imageUrl: 'https://source.unsplash.com/800x600/?metaphor,comparison,writing',
        imageAlt: '比喻修辭示意圖'
      },
      {
        id: 2,
        question: '擬人修辭的特點是什麼？',
        answer: '把事物人格化，使文章更生動有趣，增強感染力',
        explanation: '擬人可以讓無生命的事物具有人的特徵，使表達更加生動活潑。',
        category: 'rhetoric',
        keywords: ['擬人', '人格化', '生動'],
        imageQuery: 'personification creative writing',
        imageUrl: 'https://source.unsplash.com/800x600/?personification,creative,writing',
        imageAlt: '擬人修辭示意圖'
      },
      {
        id: 3,
        question: '排比的作用有哪些？',
        answer: '增強語言氣勢，加強感情色彩，使條理更清楚',
        explanation: '排比通過結構相似的句子，能夠營造強烈的節奏感和感情效果。',
        category: 'rhetoric',
        keywords: ['排比', '氣勢', '條理'],
        imageQuery: 'parallel structure rhythm',
        imageUrl: 'https://source.unsplash.com/800x600/?parallel,structure,rhythm',
        imageAlt: '排比修辭示意圖'
      },
      {
        id: 4,
        question: '對偶的基本要求是什麼？',
        answer: '字數相等，詞性相對，結構相同，意義相關',
        explanation: '對偶要求兩個句子在形式上完全對應，在內容上相互呼應。',
        category: 'rhetoric',
        keywords: ['對偶', '字數', '詞性', '結構'],
        imageQuery: 'couplet balance symmetry',
        imageUrl: 'https://source.unsplash.com/800x600/?couplet,balance,symmetry',
        imageAlt: '對偶修辭示意圖'
      },
      {
        id: 5,
        question: '反問句的表達效果是什麼？',
        answer: '加強語氣，增強感情色彩，引起讀者思考',
        explanation: '反問句用疑問的形式表達肯定的意思，語氣更加強烈。',
        category: 'rhetoric',
        keywords: ['反問', '語氣', '感情'],
        imageQuery: 'rhetorical question emphasis',
        imageUrl: 'https://source.unsplash.com/800x600/?rhetorical,question,emphasis',
        imageAlt: '反問句示意圖'
      },
      {
        id: 6,
        question: '設問和反問有什麼區別？',
        answer: '設問自問自答，反問只問不答；設問引起注意，反問加強語氣',
        explanation: '設問是為了引起讀者思考，反問是為了強調自己的觀點。',
        category: 'rhetoric',
        keywords: ['設問', '反問', '區別'],
        imageQuery: 'question types writing',
        imageUrl: 'https://source.unsplash.com/800x600/?question,types,writing',
        imageAlt: '設問反問對比圖'
      }
    ]
  },
  {
    id: 'argumentative-structure-zh',
    title: '議論文結構',
    language: '繁體中文',
    difficulty: 'intermediate',
    category: 'argumentative',
    totalCards: 4,
    description: '議論文的基本結構和論證方法',
    createdAt: '2024-01-17T09:15:00Z',
    cards: [
      {
        id: 1,
        question: '議論文的三要素是什麼？',
        answer: '論點、論據、論證',
        explanation: '論點是作者的觀點，論據是支持論點的材料，論證是論點和論據之間的邏輯關係。',
        category: 'argumentative',
        keywords: ['議論文', '三要素', '論點', '論據', '論證'],
        imageQuery: 'argument structure logic',
        imageUrl: 'https://source.unsplash.com/800x600/?argument,structure,logic',
        imageAlt: '議論文三要素圖'
      },
      {
        id: 2,
        question: '常用的論證方法有哪些？',
        answer: '舉例論證、道理論證、對比論證、比喻論證',
        explanation: '不同的論證方法適用於不同的情況，合理運用能增強說服力。',
        category: 'argumentative',
        keywords: ['論證方法', '舉例', '道理', '對比', '比喻'],
        imageQuery: 'proof methods reasoning',
        imageUrl: 'https://source.unsplash.com/800x600/?proof,methods,reasoning',
        imageAlt: '論證方法示意圖'
      },
      {
        id: 3,
        question: '議論文的基本結構是什麼？',
        answer: '提出問題（引論）、分析問題（本論）、解決問題（結論）',
        explanation: '這是議論文最常見的三段式結構，邏輯清晰，層次分明。',
        category: 'argumentative',
        keywords: ['基本結構', '引論', '本論', '結論'],
        imageQuery: 'essay structure outline',
        imageUrl: 'https://source.unsplash.com/800x600/?essay,structure,outline',
        imageAlt: '議論文結構圖'
      },
      {
        id: 4,
        question: '如何確立正確的論點？',
        answer: '論點要明確、正確、有針對性，一般在文章開頭或結尾提出',
        explanation: '好的論點是議論文的靈魂，必須旗幟鮮明，不能模糊不清。',
        category: 'argumentative',
        keywords: ['論點', '明確', '正確', '針對性'],
        imageQuery: 'thesis statement clear',
        imageUrl: 'https://source.unsplash.com/800x600/?thesis,statement,clear',
        imageAlt: '論點確立示意圖'
      }
    ]
  }
];

// 學習卡片設置和偏好
export const flashCardSettings = {
  autoAdvanceDelay: 3000, // 毫秒
  defaultNumberOfCards: 5,
  maxNumberOfCards: 20,
  enableSound: true,
  enableAutoAdvance: true,
  showExplanations: true,
  shuffleCards: false
};

// 輔助函數
export const getLanguageByCode = (code) => {
  return flashCardLanguages.find(lang => lang.code === code) || flashCardLanguages[0];
};

export const getDifficultyById = (id) => {
  return flashCardDifficulties.find(diff => diff.id === id) || flashCardDifficulties[1];
};

export const getCategoryById = (id) => {
  return flashCardCategories.find(cat => cat.id === id) || flashCardCategories[flashCardCategories.length - 1];
};

export const generateFlashCardId = (title, language, difficulty) => {
  const cleanTitle = title.toLowerCase().replace(/[^a-z0-9]/g, '-');
  const langCode = language.toLowerCase().replace(/[^a-z]/g, '');
  return `${cleanTitle}-${langCode}-${difficulty}`;
}; 